'use strict';

import query from './query';
import core from './core';
import settings from './settings';
import lifecycle from './lifecycle';

export default {
  query,
  core,
  settings,
  lifecycle,
};
